import React from "react";

const UnAssignEmp = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M12.243 28.526a11.975 11.975 0 0011.435.043c-.61-.773-13.342-13.612-13.342-13.612a7.935 7.935 0 00-.134 1.337l-1.588 3.177a.955.955 0 00.152 1.082.969.969 0 00.311.227l1.202.546.693 2.602a1.424 1.424 0 001.386 1.084h2.654v1.312a10.953 10.953 0 00-2.77 2.202zM24.145 10.857a8.03 8.03 0 00-5.713-2.366h-.307A7.874 7.874 0 0014.17 9.55l11.205 11.204c.744-1.355 1.136-2.786 1.136-4.184a8.03 8.03 0 00-2.367-5.713z"
            fill={fill}
        />
        <path className="u_fill"
            d="M29.314 6.686A16 16 0 106.687 29.313 16 16 0 0029.314 6.686zM31 18a12.926 12.926 0 01-2.349 7.444L10.556 7.35A12.927 12.927 0 0118 5c7.168 0 13 5.832 13 13zM5 18a12.927 12.927 0 012.349-7.444L25.444 28.65A12.927 12.927 0 0118 31c-7.168 0-13-5.832-13-13z"
            fill={fill}
        />
    </svg>
);

export default UnAssignEmp;